import {LoginForm, AuthInitState, AuthResponse, LoginInfo} from '@/store/auth/auth.types';
import {ActionContext, ActionTree} from 'vuex';
import {RootState} from '@/store/type';
import {ResponseMessages} from '@/class/http';
import {AuthEnum} from '@/store/auth/auth.enum';
import {HttpService} from '@/services/api';

export const AuthenAction: ActionTree<AuthInitState, RootState> = {
  async _LoginMember({commit, dispatch, rootState, rootGetters}: ActionContext<AuthInitState, RootState>, payload: LoginForm): Promise<void> {
    try {
      let auth = await HttpService.postForLogin('/auth/login', payload, process.env.VUE_APP_API_AUTH);
      if(auth.data.appCode === 20000) {
        let loginInfo: LoginInfo[] = auth.data.data;
        let weakPassword = await HttpService.get(`/auth/weak-password/${loginInfo[0].id}`, payload, process.env.VUE_APP_API_AUTH);
        localStorage.setItem(AuthEnum.weakPassword, weakPassword.data.data);
        localStorage.setItem(AuthEnum.Auth, JSON.stringify(loginInfo[0]));
        commit('MAIN_LOGIN', loginInfo, {root: true});
      }
      return auth.data.appCode;
    } catch (e) {
      console.error('DEBUG: _login ', e);
    }
  },

  async _renewToken({commit}) {
    try {
      let auth = await HttpService.get('/auth/renewToken/member', {}, process.env.VUE_APP_API_AUTH);
      let loginInfo: LoginInfo[] = auth.data.data;
      localStorage.setItem(AuthEnum.Auth, JSON.stringify(loginInfo[0]));
    } catch (e) {
      throw e;
    }
  },
  async _weakPassword({commit, dispatch, rootState, rootGetters}: ActionContext<AuthInitState, RootState>, payload: LoginForm): Promise<void> {
    try {
      let loginInfo: LoginInfo = JSON.parse(localStorage.getItem(AuthEnum.Auth) as string) as LoginInfo;
      let weakPassword = await HttpService.get(`/auth/weak-password/${loginInfo.id}`, payload, process.env.VUE_APP_API_AUTH);
      localStorage.setItem(AuthEnum.weakPassword, weakPassword.data.data);
    } catch (e) {
      console.error('DEBUG: _login ', e);
    }
  }
};
